export default __webpack_public_path__ + "static/media/42.3757930b.jpg";